import { Outlet, useParams, useNavigate, useLocation } from "react-router-dom";
import I18n, { LOCALES, DEFAULT_LOCALE } from "../locales";
import { STATEMENT_KEYS } from "../statements";
import { createContext, useEffect } from "react";

export const LocaleContext = createContext();

export function LocalizationWrapper() {
  const { locale, statement } = useParams();
  const i18n = new I18n(locale);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!LOCALES.includes(locale)) {
      if (STATEMENT_KEYS.includes(locale)) {
        navigate(`/${DEFAULT_LOCALE}/${locale}`);
      } else if (STATEMENT_KEYS.includes(statement)) {
        navigate(`/${DEFAULT_LOCALE}/${statement}`);
      } else {
        navigate(
          `/${DEFAULT_LOCALE}${location.pathname.replace(`/${locale}`, "")}`,
        );
      }
    }
  });

  return (
    <LocaleContext.Provider value={i18n}>
      <Outlet />
    </LocaleContext.Provider>
  );
}
